"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const global_1 = require("../global");
var FovFieldTypes;
(function (FovFieldTypes) {
    FovFieldTypes["Goal"] = "goal";
    FovFieldTypes["GoalId"] = "goal:id";
    FovFieldTypes["GoalReference"] = "goal:reference";
    FovFieldTypes["SegmentId"] = "segment:id";
    FovFieldTypes["TextSeen"] = "segment:textSeen";
    FovFieldTypes["VisitText"] = "visit:text";
    FovFieldTypes["IsReturning"] = "visit:isNew";
    FovFieldTypes["NumberVisits"] = "visit:number";
    FovFieldTypes["Language"] = "visitor:language";
    FovFieldTypes["Connection"] = "visit:connectionType";
    FovFieldTypes["AppVersion"] = "visit:appVersion";
    FovFieldTypes["DynamicVariable"] = "dynamicVar";
    FovFieldTypes["DeviceModel"] = "device:manufacturer";
    FovFieldTypes["DeviceModelVersion"] = "device:model";
    FovFieldTypes["OsVersion"] = "device:osVersion";
    FovFieldTypes["Transaction"] = "visit:isBuyer";
    FovFieldTypes["Amount"] = "visit:amount";
    FovFieldTypes["NumberPageViews"] = "visit:pageviews";
    FovFieldTypes["VisitDuration"] = "visit:durationTime";
    FovFieldTypes["Referrer"] = "source:from";
    FovFieldTypes["GeographicCity"] = "location:city";
    FovFieldTypes["GeographicArea"] = "location:country";
    FovFieldTypes["Test"] = "version:id";
    FovFieldTypes["CustomVariable"] = "customVar";
    FovFieldTypes["Browser"] = "browser:name";
    FovFieldTypes["BrowserVersion"] = "browser:version";
    FovFieldTypes["Os"] = "browser:platform";
    FovFieldTypes["WebOsVersion"] = "browser:platformVersion";
    FovFieldTypes["Resolution"] = "browser:resolution";
    FovFieldTypes["LandingPath"] = "visit:landingPath";
    FovFieldTypes["LandingPage"] = "visit:landingPage";
    FovFieldTypes["ExitPage"] = "visit:exitPath";
    FovFieldTypes["NumberPageviews"] = "visit:pageviews";
    FovFieldTypes["PageHostViewed"] = "page:host";
    FovFieldTypes["PagePathViewed"] = "page:path";
    FovFieldTypes["PageQueryParamsViewed"] = "page:query";
    FovFieldTypes["PageEvent"] = "page:pageEvent";
    FovFieldTypes["PageText"] = "page:text";
    FovFieldTypes["SegmentMerch"] = "segment:merch";
    FovFieldTypes["SegmentMerchProduct"] = "segment:merchProduct";
    FovFieldTypes["SegmentMerchCategoryBrand"] = "segment:merchCategoryBrand";
    FovFieldTypes["ErrorMessage"] = "error:message";
    FovFieldTypes["ErrorFileName"] = "error:filename";
    FovFieldTypes["ErrorLineNumber"] = "error:lineNumber";
    FovFieldTypes["ErrorColumnNumber"] = "error:colNumber";
    FovFieldTypes["ErrorType"] = "error:type";
    FovFieldTypes["ApiErrorURL"] = "errorApi:url";
    FovFieldTypes["ApiErrorStatusCode"] = "errorApi:statusCode";
    FovFieldTypes["ApiErrorMethod"] = "errorApi:method";
    FovFieldTypes["ApiErrorType"] = "errorApi:type";
})(FovFieldTypes = exports.FovFieldTypes || (exports.FovFieldTypes = {}));
var ActionType;
(function (ActionType) {
    ActionType["Click"] = "click";
    ActionType["Change"] = "change";
    ActionType["Focus"] = "focus";
    ActionType["Tap"] = "tap";
    ActionType["Pageview"] = "pageview";
    ActionType["Hover"] = "hover";
    ActionType["HoverTime"] = "hoverTime";
    ActionType["ExitPage"] = "exitPage";
    ActionType["ExitZone"] = "exitZone";
    ActionType["Purchase"] = "purchase";
    ActionType["AddToCart"] = "addToCart";
    ActionType["MetricBounce"] = "metric:bounce";
    ActionType["MetricScrollRate"] = "metric:scrollRate";
    ActionType["MetricTimeBeforeFirstClick"] = "metric:timeBeforeFirstClick";
    ActionType["MetricHesitationTime"] = "metric:hesitationTime";
    ActionType["MetricHoverTime"] = "metric:hoverTime";
    ActionType["MetricTimeSpent"] = "metric:timeSpent";
    ActionType["MetricClickRepetition"] = "metric:clickRepetition";
    ActionType["RageClick"] = "friction:rageClick";
    ActionType["QualifiedBouncers"] = "friction:qualifiedBouncers";
    ActionType["MultiplePageRevisit"] = "friction:multiplePageRevisit";
    ActionType["MultipleButtonInteraction"] = "friction:multipleButtonInteraction";
    ActionType["MultipleFieldInteraction"] = "friction:multipleFieldInteraction";
    ActionType["LoadingTime"] = "friction:loadingTime";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var FovNodeTypes;
(function (FovNodeTypes) {
    FovNodeTypes["AND"] = "AND";
    FovNodeTypes["OR"] = "OR";
    FovNodeTypes["NOT"] = "NOT";
    FovNodeTypes["SEQ"] = "SEQ";
    FovNodeTypes["DIRECTLY_THEN"] = "DIR";
    FovNodeTypes["FILTER"] = "filter";
})(FovNodeTypes = exports.FovNodeTypes || (exports.FovNodeTypes = {}));
var FovValueOperator;
(function (FovValueOperator) {
    FovValueOperator["EQUAL"] = "=";
    FovValueOperator["GREATER"] = ">";
    FovValueOperator["LESS"] = "<";
    FovValueOperator["GREATER_OR_EQUAL"] = ">=";
    FovValueOperator["LESS_OR_EQUAL"] = "<=";
    FovValueOperator["NOT_EQUAL"] = "!=";
    FovValueOperator["BETWEEN"] = "between";
})(FovValueOperator = exports.FovValueOperator || (exports.FovValueOperator = {}));
var FovPageType;
(function (FovPageType) {
    FovPageType["ANY"] = "any";
    FovPageType["URL"] = "url";
    FovPageType["PAGE"] = "page";
})(FovPageType = exports.FovPageType || (exports.FovPageType = {}));
exports.FovGroupTypes = Object.freeze([
    FovNodeTypes.AND,
    FovNodeTypes.OR,
    FovNodeTypes.SEQ,
    FovNodeTypes.DIRECTLY_THEN,
]);
exports.FOV_EMPTY = {
    children: [],
    nodeType: FovNodeTypes.AND,
};
exports.FOV_ALL_VISITORS = {
    nodeType: FovNodeTypes.FILTER,
    field: FovFieldTypes.SegmentId,
    operator: global_1.ComparisonOperators.MATCH_EQUALS,
    value: -1,
};
var FovGoalEmerchType;
(function (FovGoalEmerchType) {
    FovGoalEmerchType["Product"] = "product";
    FovGoalEmerchType["Category"] = "category";
    FovGoalEmerchType["Brand"] = "brand";
})(FovGoalEmerchType = exports.FovGoalEmerchType || (exports.FovGoalEmerchType = {}));
//# sourceMappingURL=fov-models.js.map